import { render, staticRenderFns } from "./CardNextAndPreviousLinks.vue?vue&type=template&id=6ddb1f07"
import script from "./CardNextAndPreviousLinks.vue?vue&type=script&lang=js"
export * from "./CardNextAndPreviousLinks.vue?vue&type=script&lang=js"
import style0 from "./CardNextAndPreviousLinks.vue?vue&type=style&index=0&id=6ddb1f07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports